// Studyo Today Backend
// Package studyo.today.planners.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/planners/v1/resources/work_icon.proto (package studyo.today.planners.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file studyo/today/planners/v1/resources/work_icon.proto.
 */
export const file_studyo_today_planners_v1_resources_work_icon = /*@__PURE__*/
  fileDesc("CjJzdHVkeW8vdG9kYXkvcGxhbm5lcnMvdjEvcmVzb3VyY2VzL3dvcmtfaWNvbi5wcm90bxIic3R1ZHlvLnRvZGF5LnBsYW5uZXJzLnYxLnJlc291cmNlcyJTCghXb3JrSWNvbhIPCgdpY29uX2lkGAEgASgJEhAKCGljb25fdXJsGAIgASgJEhEKCWljb25fbmFtZRgDIAEoCRIRCglpc19oaWRkZW4YBCABKAhCKqoCJ1N0dWR5by5Ub2RheS5QbGFubmVycy5HcnBjLlYxLlJlc291cmNlc2IGcHJvdG8z");

/**
 * Describes the message studyo.today.planners.v1.resources.WorkIcon.
 * Use `create(WorkIconSchema)` to create a new message.
 */
export const WorkIconSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_planners_v1_resources_work_icon, 0);

